// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import registerServiceWorker, { ServiceWorkerNoSupportError } from 'service-worker-loader!./sw';
import swURL from 'sw-loader!./sw.js'; // eslint-disable-line
import Vue from 'vue';
import 'babel-polyfill';
import * as basicLightbox from 'basiclightbox';
import vbclass from 'vue-body-class';
import App from './App';
import router from './router';

// console.log(process.env.CONFIG_URL);
// registerServiceWorker({ scope: '/' }).then(() => {
//   console.log('Success!');
// }).catch((err) => {
//   if (err instanceof ServiceWorkerNoSupportError) {
//     console.log('ServiceWorker is not supported.');
//   } else {
//     console.log('Error!');
//   }
// });

if (navigator.serviceWorker) {
  navigator.serviceWorker
    .register(swURL)
    .catch(console.warn()); // eslint-disable-line no-console
}

window.lightbox = function lightbox(image) {
  basicLightbox.create(`<div class="modal"><img src="${image}" alt="Lightbox"></div>`).show();
};

Vue.use(vbclass, router);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js